

export default class FoodImageModel {
  private constructor(
      readonly image: string
  ) {
  }

  public static createList(response: string[]): FoodImageModel[] {
    return response.map((item: string) => {
      return new FoodImageModel(
        item
      )
    })
  }

  public static create(response: string): FoodImageModel {
      return new FoodImageModel(
          response
      )
  }
}